module.exports = "/assets/logo_sg_indesign_1_1-608353238c0fdce54cb8aa5e564a654a.png";